import { ControlledForm, ControlledTable } from "Components";
import { FormDataType } from "DataTypes/Form";
import { columnType } from "DataTypes/Table";
import { BreadArrType } from "DataTypes/Common";

export const TableCol: () => columnType[] = () => {
  return [
    ControlledTable.ColumnData.CallNameCol("15%"),
    ControlledTable.ColumnData.DateTimeCol("15%"),
    ControlledTable.ColumnData.CallResultCol("15%"),
    ControlledTable.ColumnData.DeviceNameCol("15%"),
    ControlledTable.ColumnData.NextCallCol("20%"),
    ControlledTable.ColumnData.CallNoteCol("20%"),
  ];
};

export const FormDataArr: () => FormDataType[] = () => {
  return [
    ControlledForm.FormData.CallerName(),
    ControlledForm.FormData.CallResult(),
    ControlledForm.FormData.SupplyName(),
    ControlledForm.FormData.NextCall(),
    ControlledForm.FormData.Activity(),
    ControlledForm.FormData.CallNotes(),
  ];
};

export const DeviceCallLogsBreadArr: BreadArrType[] = [
  {
    id: 1,
    label: "Home",
    path: "/",
  },
  {
    id: 2,
    label: "Call Logs",
    path: "",
  },
];
